import React from 'react';
import { OpenMessageIcon } from '../../../../../../global/icons/icons';
import Text from '../../../../../../global/text/text';
import { IntlShape } from 'react-intl';
import { TO_PREVIEW_EMAIL_SAVE_IT_FIRST } from '../scheduled-email-form/scheduled-email-form.texts';

export interface IScheduledEmailsFormHeaderProps {
    handleSendPreview: () => Promise<void>;
    isEdit: boolean;
    intl: IntlShape;
}

export const ScheduledEmailsFormHeader = ({
    handleSendPreview,
    isEdit,
    intl,
}: IScheduledEmailsFormHeaderProps) => {
    return (
        <div className='oe-popup-layout__header emails-template-form-layout scheduled-email-form__header'>
            <div className='emails-template-form-header'>
                <div className='emails-template-form-header__item'></div>
                <div className='emails-template-form-header__item'>
                    { isEdit
                        ? <button className='send-preview' onClick={handleSendPreview}>
                            <OpenMessageIcon/>
                            <Text className='send-preview-text' message='Send Preview'/>
                        </button>
                        : <div className='line-height-26px italic'>
                            { intl.formatMessage(TO_PREVIEW_EMAIL_SAVE_IT_FIRST) }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};
